import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import {Link} from "react-scroll";

import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/GitHub';
import InstagramIcon from '@material-ui/icons/Instagram';
import MailIcon from '@material-ui/icons/Mail';
const useStyles = makeStyles({
  root: {
    width: "100%",
    backgroundColor:"rgba(22,33,90,255)",
    overflow:"hidden"
  },
  icon:{
      color:"white"
  }
});

export default function Nav() {
  const classes = useStyles();
  const [value, setValue] = React.useState('recents');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div id="home">
    <BottomNavigation  value={value} onChange={handleChange} className={classes.root}>
        <BottomNavigationAction className={classes.icon} value="recents" icon={<a href="https://www.linkedin.com/in/akash-ekanayaka/"><LinkedInIcon className={classes.icon}/></a>} />
        <BottomNavigationAction  value="recents" icon={<a href="https://github.com/vae97"><GitHubIcon className={classes.icon}/></a>} />
        <BottomNavigationAction  value="recents" icon={<a href="https://www.instagram.com/akash_ekanayaka/"><InstagramIcon className={classes.icon}/></a>} />
        
        
    
                         <BottomNavigationAction  value="recents" icon={<Link activeClass="active" to="gmail" spy={true} smooth={true} offset={0} duration={1000}> 
                         <MailIcon className={classes.icon}/> </Link>} />
        
    </BottomNavigation>
    </div>
  );
}
